import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { Tab, Tabs } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { currentUserPersonQuery } from '../../api'
import CourseView from './courses'
import EducationView from './educations'
import LanguagesView from './languages'
import SkillsView from './skills'

export default function CompetencesView({ isPersonal }) {
	const { t } = useTranslation()

	const localStorageKey = 'competencesTabSelection'
	const [key, setKey] = useState(localStorage.getItem(localStorageKey) ?? 'educations')
	const storeKeySelection = (selection) => localStorage.setItem(localStorageKey, selection)

	const selectKey = (k) => {
		storeKeySelection(k)
		setKey(k)
	}

	const person = useQuery(currentUserPersonQuery(isPersonal)).data

	return (
		<>
			<h2 className="viewheading">{t('Competences', 'Osaaminen')}</h2>
			<Tabs activeKey={key} onSelect={selectKey} unmountOnExit>
				<Tab eventKey="educations" title={t('Educations', 'Tutkinnot')}>
					<EducationView person={isPersonal && person} />
				</Tab>
				<Tab eventKey="courses" title={t('OtherEducation', 'Muu koulutus')}>
					<CourseView person={isPersonal && person} />
				</Tab>
				<Tab eventKey="skills" title={t('Skills', 'Taidot')}>
					<SkillsView person={isPersonal && person} />
				</Tab>
				<Tab eventKey="languages" title={t('LanguageSkill', 'Kielitaito')}>
					<LanguagesView person={isPersonal && person} />
				</Tab>
			</Tabs>
		</>
	)
}
